export interface LanguageOption {
  code: string; // "en" | "hi" | "fr" | "or" (matches i18next lng codes)
  label: string; // "English"
  nativeLabel: string; // "हिन्दी"
}

// Static for now. When backend is ready, replace body with:
// const { data } = await privateClient.get(endpoints.languages.list);
// return data.languages ?? data;
export const getAvailableLanguages = async (): Promise<LanguageOption[]> => {
  return [
    { code: "en", label: "English", nativeLabel: "English" },
    { code: "hi", label: "Hindi", nativeLabel: "हिन्दी" },
    { code: "fr", label: "French", nativeLabel: "Français" },
    { code: "or", label: "Odia", nativeLabel: "ଓଡ଼ିଆ" },
  ];
};